import { useQueryGetReportsTags } from 'api/queries/getReportsTags.query';

export type UseReportTagsSelectWithCreateProvider = ReturnType<typeof useReportTagsSelectWithCreateProvider>;

export const useReportTagsSelectWithCreateProvider = () => {
    const getReportsTags = useQueryGetReportsTags();

    return {
        api: {
            getReportsTags,
        },
    };
};
